import { render, staticRenderFns } from "./add-author.vue?vue&type=template&id=736a24fb&scoped=true"
import script from "./add-author.vue?vue&type=script&lang=js"
export * from "./add-author.vue?vue&type=script&lang=js"
import style0 from "./add-author.vue?vue&type=style&index=0&id=736a24fb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736a24fb",
  null
  
)

export default component.exports